import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/assets/logo.png'
import _imports_1 from './assets/i0.png'
import _imports_2 from './assets/i1.png'
import _imports_3 from './assets/i2.png'


const _withScopeId = n => (_pushScopeId("data-v-2e72488a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default p1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "c-primary" }
const _hoisted_4 = { class: "contin" }
const _hoisted_5 = { class: "page-default p2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_7 = { class: "t1" }
const _hoisted_8 = { class: "t2" }
const _hoisted_9 = { class: "btn" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_12 = { class: "t1" }
const _hoisted_13 = { class: "t2" }
const _hoisted_14 = { class: "btn" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_17 = { class: "t1" }
const _hoisted_18 = { class: "t2" }
const _hoisted_19 = { class: "btn" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "p3" }
const _hoisted_22 = { class: "page-default page-media" }
const _hoisted_23 = { style: {"margin-top":"10px"} }
const _hoisted_24 = { class: "p4" }
const _hoisted_25 = { class: "page-default page-media" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_27 = ["href"]

import contents from '@/views/assets/contents';
import { onMounted, reactive, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const store = useStore()
const configData = computed<RootState>(() => store.state.moviesConfig)
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].bible)

const state = reactive({
    volume: -1,
    chapter: -1,
    text: ''
})
onMounted(() => {
    let last = window.localStorage.getItem('blast')
    if (last) {
        let [volume, chapter] = last.split('-')
        if (parseInt(volume) >= 0 && parseInt(chapter) >= 0) {
            state.volume = parseInt(volume)
            state.chapter = parseInt(chapter)
            state.text = contents[state.volume].tag + ' 第' + (state.chapter + 1) + '章'
        }
    }
})
function onLast() {
    let volume = state.volume
    let chapter = state.chapter
    router.push({
        name: 'bible-detail',
        params: {
            volume: volume + 1,
            chapter: chapter + 1,
            lang: '0',
        }
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(lang).home_title), 1),
      _createElementVNode("div", _hoisted_4, [
        (_unref(state).text)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: onLast
            }, _toDisplayString(_unref(lang).home_continue) + " " + _toDisplayString(_unref(state).text), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(lang).home_audio), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(lang).home_audio_intro), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            href: _unref(configData).downloadUrl,
            target: "_blank"
          }, _toDisplayString(_unref(lang).home_audio_do), 9, _hoisted_10)
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(lang).home_text), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(lang).home_text_intro), 1),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            href: _unref(configData).downloadUrl,
            target: "_blank"
          }, _toDisplayString(_unref(lang).home_text_do), 9, _hoisted_15)
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(lang).home_app), 1),
        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(lang).home_app_intro), 1),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", {
            href: _unref(configData).downloadUrl,
            target: "_blank"
          }, _toDisplayString(_unref(lang).home_app_do), 9, _hoisted_20)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", null, _toDisplayString(_unref(lang).home_bible), 1),
        _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(lang).home_bible_from), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("span", null, _toDisplayString(_unref(lang).app), 1),
        _createElementVNode("a", {
          href: _unref(configData).downloadUrl,
          target: "_blank"
        }, _toDisplayString(_unref(lang).app_download), 9, _hoisted_27)
      ])
    ])
  ]))
}
}

})